@for (category of categories; track $index) {

<div class="title-wrapper">
  <p>{{category.name | titlecase}}</p>
</div>
<div class="categories-wrapper">

  @for(category of category.childs; track $index){
  <a class="btn btn-light category" [routerLink]="rulesService.getCategoryPageUrl(category)">
    <div class="img-wrapper">
      <app-asset [assetId]="category.assetId"></app-asset>
    </div>
    <div class="name">
      {{category.name.toUpperCase()}}
    </div>
  </a>
  }

</div>

}
